// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LNmw","placeholdersHeader":"styles_placeholdersHeader__3XwyA","editorStyle":"styles_editorStyle__3o-q3","placeholdersBox":"styles_placeholdersBox__2wy_h"};